export default {"src":"/_next/static/media/highlights-icon-1.4bb5eb8d.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};